export { default as ProductSidebarSkeleton } from "./ProductSidebarSkeleton";
